var _path, _path2, _path3, _path4, _path5, _ellipse, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscoverys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.127 4.996L.27 6.886 0 4.186 30.525 0h10.94v93.435H52V96H.945v-2.565h14.182V4.995z",
    fill: "url(#discovery_s_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29.222L57.333 23v49.778L36 79V29.222z",
    fill: "#265682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.333 72.028V24.333l19.334 5.64v47.694l-19.334-5.64z",
    stroke: "#265682",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.667 29.222L100 23v49.778L78.667 79V29.222z",
    fill: "#265682"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.693 24.797C84.693 34.075 68.318 53 68.318 53S51.693 34.075 51.693 24.797C51.693 15.52 59.08 8 68.193 8s16.5 7.52 16.5 16.797z",
    fill: "#D6BB96"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.956,
    cy: 23.919,
    rx: 6.981,
    ry: 7.107,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discovery_s_svg__paint0_linear",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2",
    stopOpacity: 0
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEyIiBoZWlnaHQ9Ijk2IiB2aWV3Qm94PSIwIDAgMTEyIDk2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTE1LjEyNzMgNC45OTU3OEwwLjI3MDEzIDYuODg2MDhMMCA0LjE4NTY2TDMwLjUyNDcgMEg0MS40NjQ5VjkzLjQzNDZINTJWOTZIMC45NDU0NTRWOTMuNDM0NkgxNS4xMjczVjQuOTk1NzhaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CiAgICA8cGF0aCBkPSJNMzYgMjkuMjIyMkw1Ny4zMzMzIDIzVjcyLjc3NzhMMzYgNzlWMjkuMjIyMloiIGZpbGw9IiMyNjU2ODIiLz4KICAgIDxwYXRoIGQ9Ik01OC4zMzM0IDcyLjAyNzhWMjQuMzMzM0w3Ny42NjY4IDI5Ljk3MjJWNzcuNjY2N0w1OC4zMzM0IDcyLjAyNzhaIiBzdHJva2U9IiMyNjU2ODIiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggZD0iTTc4LjY2NjYgMjkuMjIyMkw5OS45OTk5IDIzVjcyLjc3NzhMNzguNjY2NiA3OVYyOS4yMjIyWiIgZmlsbD0iIzI2NTY4MiIvPgogICAgPHBhdGggZD0iTTg0LjY5MyAyNC43OTc1Qzg0LjY5MyAzNC4wNzQ1IDY4LjMxODMgNTMgNjguMzE4MyA1M0M2OC4zMTgzIDUzIDUxLjY5MyAzNC4wNzQ1IDUxLjY5MyAyNC43OTc1QzUxLjY5MyAxNS41MjA1IDU5LjA4MDMgOCA2OC4xOTMgOEM3Ny4zMDU3IDggODQuNjkzIDE1LjUyMDUgODQuNjkzIDI0Ljc5NzVaIiBmaWxsPSIjRDZCQjk2Ii8+CiAgICA8ZWxsaXBzZSBjeD0iNjcuOTU2NCIgY3k9IjIzLjkxOTEiIHJ4PSI2Ljk4MDc3IiByeT0iNy4xMDY2MiIgZmlsbD0id2hpdGUiLz4KICAgIDxkZWZzPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjI2IiB5MT0iMCIgeDI9IjI2IiB5Mj0iOTYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0VCRUZGMiIvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNFQkVGRjIiIHN0b3Atb3BhY2l0eT0iMCIvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgDiscoverys as ReactComponent };